// ------------------------------------
// props 輸入需求 : 
// props.data : object : { data: array }            (  )
// ------------------------------------

import React from 'react'
import { useTranslation } from 'react-i18next';
import '../_Resident.scss'


const ResidentName =(props)=>{
    const { t } = useTranslation();

    return(
        <div className="flex-grow-1 body-container">
            <div className="body">
                <div>&nbsp;</div>
                <div>{props.last_name}</div>
                <div className="check-history cursor pt" onClick={()=>{
                    props.toggleHisPanel()
                    }}>{t('RESIDENTS.VIEW_HISTORY')}</div>
            </div>
        </div>
    );	

}
export default ResidentName;